import React from 'react';
import { settings } from '../../config/settings';
import ControlService from '../../helper/controlservice';


export const initiateAuth = async (token) => {
    const _control = {
        method: 'post',
        datasource: 'http'
    }
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.QUICKBOOKS_INITIATE_AUTH_API, {}, _control, token, null)
        .then(res => { return res });
}
export const generateAccessToken = async (token) => {
    const _control = {
        method: 'get',
        datasource: 'http'
    }
    let code = ControlService().GetParamUrl('code');
    let realmId = ControlService().GetParamUrl('realmId');

    let apiParam = {
        'code': code,
        'companyId': realmId
    }
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.QUICKBOOKS_GENARTE_TOKEN_API, apiParam, _control, token, null)
        .then(res => { return res });
}
export const isQuickbookRegistered = async (token) => {
    const _control = {
        method: 'get',
        datasource: 'http'
    }
    let apiParam = {}
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.QUICKBOOKS_TOKEN_ISVALID_API, apiParam, _control, token, null)
        .then(res => { return res });
}